export default __webpack_public_path__ + "static/media/arrow-left-2.8f081197.svg";